import React from 'react';
import Header from './Header';

function Frame({ children }) {
    return (
        <div>
            <Header />
            <main className='main-container' style={{ paddingTop: '200px' }}>
                {children}
            </main>
        </div>
    );
}

export default Frame;